import { render, staticRenderFns } from "./returnrecord.vue?vue&type=template&id=288d2b56&scoped=true&"
import script from "./returnrecord.vue?vue&type=script&lang=js&"
export * from "./returnrecord.vue?vue&type=script&lang=js&"
import style0 from "./returnrecord.vue?vue&type=style&index=0&id=288d2b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288d2b56",
  null
  
)

export default component.exports